export default "__VITE_ASSET__C6OALcAA__"